/* ============================================================
   Watch Reserves — welcome-credit countdown in the cart.

   The deadline is real: the relay mints each welcome code with an endsAt
   (DISCOUNT_DAYS_VALID), and wr-welcome-offer.js stores that expiry next
   to the code. This only counts down to it. Nothing here resets, extends
   or invents a deadline — if there is no stored expiry, or it has passed,
   the block stays hidden.

   Runs off a single document-level interval rather than binding to the
   markup, because the drawer's contents are replaced wholesale on every
   add/change (Section Rendering API) and a fresh block has to pick up the
   countdown without this file being re-run.
   ============================================================ */
(function () {
  'use strict';

  if (window.wrCreditTimer) return;
  window.wrCreditTimer = true;

  function stored(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }

  // Read on every tick, not once: a visitor can claim the code from the
  // pop-up and open the drawer without a page load in between.
  function credit() {
    var code = stored('wr-offer-code');
    var expires = Date.parse(stored('wr-offer-expires') || '');
    // Codes claimed before the expiry was stored have no deadline to show.
    if (!code || !expires) return null;
    return {
      code: code,
      expires: expires,
      amount: Number(stored('wr-offer-amount')) || 25,
      minimum: Number(stored('wr-offer-minimum')) || 0
    };
  }

  // Re-apply once per session, so the credit is already in place at
  // checkout even if the visitor never pastes it (the cookie can be lost).
  function applyOnce(c) {
    try {
      if (window.sessionStorage.getItem('wr-offer-applied') === c.code) return;
      window.sessionStorage.setItem('wr-offer-applied', c.code);
    } catch (e) { return; }
    fetch('/discount/' + encodeURIComponent(c.code), { credentials: 'same-origin' }).catch(function () {});
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function tick() {
    var blocks = document.querySelectorAll('[data-wr-credit-timer]');
    var c = credit();
    if (!c) return;
    var left = c.expires - Date.now();
    if (left > 0) applyOnce(c);
    if (!blocks.length) return;

    for (var i = 0; i < blocks.length; i++) {
      var b = blocks[i];
      if (left <= 0) { b.hidden = true; continue; }

      var s = Math.floor(left / 1000);
      var h = Math.floor(s / 3600);
      // Under an hour, drop the leading 00 so a short window reads 29 : 41.
      var clock = (h ? pad(h) + ' : ' : '') + pad(Math.floor(s / 60) % 60) + ' : ' + pad(s % 60);

      var amountEl = b.querySelector('[data-wr-credit-amount]');
      var clockEl = b.querySelector('[data-wr-credit-clock]');
      var noteEl = b.querySelector('[data-wr-credit-note]');
      if (amountEl) amountEl.textContent = '$' + c.amount;
      if (clockEl) clockEl.textContent = clock;
      if (noteEl) {
        // The minimum is in USD. In another market the subtotal is in local
        // currency, so don't compare across currencies — just state the floor.
        // The add-to-cart confirmation's block was rendered with the page,
        // before the add. The drawer's cart section is re-rendered on every
        // add, so take the subtotal from there when it exists.
        var fresh = document.querySelector('#shopify-section-wr-cart-drawer-section [data-wr-credit-timer]');
        var src = (fresh && b.closest('[data-wr-cart-confirm]')) ? fresh.dataset : b.dataset;
        var subtotal = Number(src.subtotal) || 0;
        if (src.currency && src.currency !== 'USD') {
          noteEl.textContent = 'Applied at checkout on orders over US$' + c.minimum + '.';
        } else {
          var short = Math.ceil(c.minimum - subtotal / 100);
          noteEl.textContent = short <= 0
            ? 'Applied automatically at checkout.'
            : 'Add $' + short + ' more to use your credit.';
        }
      }
      b.hidden = false;
    }
  }

  tick();
  window.setInterval(tick, 1000);
})();
